/**
 * 5.3.1.1 공통 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

export const state = () => ({
  // api url 목록
  apiUrl: {
    // 공통설정 API URL
    payConfigUrl: '/api/pm/pay-config',
    payAprvalUrl: '/api/pm/pay-aprval/chk'
  },

  payConfig: {
    'pams.check.ip_yn': '', //        PAMS IP 검출 여부
    'pams.check.port_yn': '', //      PAMS Port 검출 여부
    'pams.check.approval_yn': '', //  PAMS 결재 문구 검출 여부
    'pams.comment.enable_yn': '', //  PAMS 정책 설명 사용 여부
    'pams.comment.rule': '' //       PAMS 정책 설명 생성 규칙
  },
  payAprval: [],
  autoCreate: {},
  payAprvalResult: null,
  payConfigResult: null,
  errorMessage: null,
  commentParam: '',
  popupSelectedContents: '',
  selectData: {
    pams_aprval_chk_id: 1,
    pams_aprval_chk_uname: ''
  }
})

export const mutations = {
  setPopupSelectedContents (state, data) {
    state.popupSelectedContents = data
  },
  clearPopupSelectedContents (state) {
    state.popupSelectedContents = ''
  },
  setCommentParam (state, data) {
    state.commentParam = data
  },
  // 공통설정 정보 조회
  mutItemPayConfig (state, payload) {
    state.payConfig[payload.key] = payload.val
  },
  mutPayConfig (state, payload) {
    for (let i = 0; i < payload.length; i++) {
      if (payload[i].config_key === 'pams.comment.rule') {
        let commentValue = payload[i].config_val
        if (commentValue.includes('{REQ_NUM}')) {
          commentValue = commentValue.replace('{REQ_NUM}', '[' + window.$nuxt.$tc('pa.requestNum') + ']')
        }
        if (commentValue.includes('{REQ_NAME}')) {
          commentValue = commentValue.replace('{REQ_NAME}', '[' + window.$nuxt.$tc('pa.requestManager') + ']')
        }
        if (commentValue.includes('{REQ_DATE}')) {
          commentValue = commentValue.replace('{REQ_DATE}', '[' + window.$nuxt.$tc('pa.requestDay') + ']')
        }
        if (commentValue.includes('{REQ_DATETIME}')) {
          commentValue = commentValue.replace('{REQ_DATETIME}', '[' + window.$nuxt.$tc('pa.requestTime') + ']')
        }
        payload[i].config_val = commentValue
      }
    }
    _.forEach(payload, (item) => {
      state.payConfig[item.config_key] = item.config_val
    })
  },
  selectedPayAprval (state, data) {
    state.selectData = data
  },
  // 결재설정 문구 조회
  mutPayAprval (state, payload) {
    state.payAprval = payload
  },
  // 연동 Key 자동 생성 조회
  mutAutoCreate (state, payload) {
    state.payConfig['pams.rest.key'] = payload.msg
  },
  // 공통설정 정보 수정
  mutPutPayConfig (state, payload) {
    state.payConfigResult = payload
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  async applyGeneralSettingsAction () {
    const result = await this.$axios.$put('/api/pm/pay-config/apply', null, {applyMsg: true, loading: true, successAlert: true})
    return result
  },
  async cancelGeneralSettingsAction () {
    const result = await this.$axios.$put(`/api/pm/pay-config/cancel`, null, {cancelMsg: true, loading: true, successAlert: true})
    return result
  },
  // 공통설정 정보 조회
  async acsPayConfig ({commit, state}, flag) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.payConfigUrl}`, {loading: flag, successAlert: flag})
      // commit('mutPayConfig', res)
      if (res.code === 'ok') {
        commit('mutPayConfig', res.result)
      } else {
        commit('mutationErrorMessage', res.result)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 결재설정 문구 조회
  async acsPayAprval ({commit, state}, flag) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.payAprvalUrl}`, null, {loading: flag, successAlert: flag})
      if (res.code === 'ok') {
        commit('mutPayAprval', res.result)
      } else {
        commit('mutationErrorMessage', res.result)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 결재설정 문구 추가
  async acsPostPayAprval ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrl.payAprvalUrl}?str=${encodeURIComponent(payload)}`)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 결재설정 문구 수정
  async acsPutPayAprval ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl.payAprvalUrl}`, payload)
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
      res.code = 'nok'
      res.result.msg = error.message
      return res
    }
  },
  // 결재설정 문구 삭제
  async acsDelPayAprval ({commit, state}, payload) {
    const result = { error: null }
    try {
      const res = await this.$axios.$delete(`${state.apiUrl.payAprvalUrl}/${payload.pams_aprval_chk_id}`)
      return res
    } catch (error) {
      result.error = error
      commit('mutationErrorMessage', result)
    }
  },
  // 연동 Key 자동 생성 조회
  async acsAutoCreate ({commit, state}) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.payConfigUrl}/sha256`)
      if (res.code === 'ok') {
        commit('mutAutoCreate', res.result)
      } else {
        commit('mutationErrorMessage', res.result)
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 공통설정 정보 수정
  async acsPutPayConfig ({commit, state}, payload) {
    try {
      let commentParam = state.commentParam
      if (commentParam.includes('[' + window.$nuxt.$tc('pa.requestNum') + ']')) {
        commentParam = commentParam.replace('[' + window.$nuxt.$tc('pa.requestNum') + ']', '{REQ_NUM}')
      }
      if (commentParam.includes('[' + window.$nuxt.$tc('pa.requestManager') + ']')) {
        commentParam = commentParam.replace('[' + window.$nuxt.$tc('pa.requestManager') + ']', '{REQ_NAME}')
      }
      if (commentParam.includes('[' + window.$nuxt.$tc('pa.requestDay') + ']')) {
        commentParam = commentParam.replace('[' + window.$nuxt.$tc('pa.requestDay') + ']', '{REQ_DATE}')
      }
      if (commentParam.includes('[' + window.$nuxt.$tc('pa.requestTime') + ']')) {
        commentParam = commentParam.replace('[' + window.$nuxt.$tc('pa.requestTime') + ']', '{REQ_DATETIME}')
      }
      const payloadParam = payload.list
      for (let i = 0; i < payloadParam.length; i++) {
        if (payloadParam[i].key === 'pams.comment.rule') {
          payload.list[i].val = commentParam
        }
      }
      const res = await this.$axios.$post(`${state.apiUrl.payConfigUrl}`, payload, {loading: true, successAlert: false})
      return res
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  }
}
export const getters = {}
export const strict = false
